<template>
  <div class="page">
    <Modal
      v-model="dialogVisible"
      class="page-modal"
      width="40%"
      :mask-closable="false"
      :footer-hide="true"
      :title="$t('common.edit')"
      class-name="vertical-center-modal"
    >
      <div class="edit-box">
        <div class="input-item">
          <Form
            ref="addForm"
            :label-width="120"
            label-position="right"
            :model="addForm"
            :label-colon="true"
            :rules="ruleValidate"
            @submit.native.prevent
          >
            <FormItem :label="$t('house.name')" prop="name">
              <Input
                v-model="addForm.name"
                size="large"
                clearable
                :placeholder="$t('house.devNameTip')"
              />
            </FormItem>

            <FormItem :label="$t('house.start')" prop="on">
              <i-switch v-model="addForm.on" size="large" />
              <span>{{ $t("house.space") }}</span>
            </FormItem>
            <FormItem :label="$t('house.see')" prop="visibleNum">
              <RadioGroup
                v-model="addForm.visibleNum"
                :true-value="1"
                :false-value="0"
                @on-change="handleChange"
              >
                <Radio
                  v-for="(item, index) in seeList"
                  :label="item.id"
                  :key="index"
                  size="large"
                >
                  <span>{{ item.label }}</span>
                </Radio>
              </RadioGroup>
            </FormItem>
            <div v-show="configVisible">
              <FormItem
                v-for="(item, index) in addForm.configList"
                :key="index"
                :label="item.label"
                v-show="itemKey === 0"
              >
                <RadioGroup v-model="item.value">
                  <Radio
                    v-for="item in option"
                    :key="item.value"
                    :label="item.value"
                  >
                    <span>{{ item.label }}</span>
                  </Radio>
                </RadioGroup>
              </FormItem>
            </div>
          </Form>
        </div>
        <div class="btn-edit">
          <Button
            type="primary"
            size="large"
            class="btn-width"
            ghost
            @click="reset"
            >{{ $t("common.reset") }}</Button
          >

          <Button type="primary" size="large" class="btn-width" @click="edit">{{
            $t("common.edit")
          }}</Button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "ModalBox",
  props: {},
  data() {
    return {
      dialogVisible: false,
      addForm: {},
      ruleValidate: {},
      seeList: JSON.parse(JSON.stringify(this.global.seeList)),
      itemKey: null,
      option: [
        { label: this.$t("threeProject.config"), value: 1 },
        { label: this.$t("threeProject.unconfig"), value: 0 },
      ],
      configVisible: false,
    };
  },
  watch: {
    dialogVisible: {
      handler() {
        if (this.dialogVisible == false) {
          // 弹窗关闭 清空数据
          this.addForm = {};
        }
      },
    },
  },
  methods: {
    closeModal() {
      this.dialogVisible = false;
    },
    reset() {
      this.$emit("reset", this.addForm, this.itemKey);
      this.closeModal();
    },
    del() {
      this.$emit("delete", this.addForm, this.itemKey);
      this.closeModal();
    },
    edit() {
      let obj = JSON.parse(JSON.stringify(this.addForm));
      obj.visible = Number(this.addForm.visibleNum) === 0 ? false : true;

      if (this.addForm.name == "" || this.addForm.name == undefined) {
        if (this.itemKey === 0) {
          obj.name = this.$t("house.mainControl") + 1;
        } else if (this.itemKey > 0) {
          obj.name = this.$t("house.sedControl") + this.itemKey;
        }
      }

      this.$emit("edit", obj, this.itemKey);
      this.closeModal();
    },
    handleChange(val) {
      this.configVisible = this.addForm.visibleNum === 1;
    },
  },
};
</script>
